import { render, staticRenderFns } from "./TableSales.vue?vue&type=template&id=7d83a343&scoped=true&"
import script from "./TableSales.vue?vue&type=script&lang=js&"
export * from "./TableSales.vue?vue&type=script&lang=js&"
import style0 from "./TableSales.vue?vue&type=style&index=0&id=7d83a343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d83a343",
  null
  
)

export default component.exports